<template>
    <div id="tab7" class="img-show">
        <div class="white-bg">
            <div class="page-width main-content">
                <!-- 产品介绍 -->
                <div>
                    <div class="sub-title">
                        <p>智能巡检系统</p>
                    </div>
                    <div class="intro">
                        智能巡检系统是一套易于拓展、升级和管理使用的综合信息管理系统，利用先进的现代化信息技术和设备，实现巡检工作的信息化管理，提高巡检人员的工作效率，进而提高设备的安全可靠性，及时消除隐患。相比传统巡检方式而言，智能巡检系统采用流程化的管理，将条码技术应用于设备巡检管理中，这样使得巡检人员的工作更加井然有序，防止巡检项遗漏，更加高效便捷；巡检全程不需要纸张介质的介入，支持拍照取证，支持离线环境上传巡检结果；智能巡检系统还能够根据每天产生的数据，自动生成数据统计分析报表，使管理人员能够更方便地掌握巡检的情况。
                    </div>
                    <img
                        src="../../../../../assets/img/softProduct/xj/业务流程.png"
                        alt=""
                        class="app-img"
                    />
                </div>
                <!-- 系统优势 -->
                <div>
                    <div class="sub-title">
                        <p>系统优势</p>
                    </div>
                    <img
                        src="../../../../../assets/img/softProduct/xj/系统优势.png"
                        alt=""
                        class="app-img"
                    />
                </div>
                <div class="sub-title">
                    <p>系统功能</p>
                </div>
            </div>
        </div>
        <div class="grey-bg">
            <!-- 系统功能 -->
            <div
                class="system-function ksh-function energy-function page-width main-content"
            >
                <div class="flex card-page flex-wrap">
                    <div class="card-text">
                        <p class="p1">巡检配置</p>
                        <p class="p2">
                            包含巡检区域、巡检点、巡检项等配置。
                            大多数巡检都是分区域进行的，所以需要对巡检区域进行管理。系统支持树状结构的多级别区域管理。
                            巡检点位按照区域进行分类管理，每一个区域有多个巡检点，每个巡检点又有多个检查项，通过这些点组成一条巡检线路。
                        </p>
                    </div>
                    <img
                        src="../../../../../assets/img/softProduct/xj/检查项.png"
                        alt=""
                        class="app-img"
                    />
                </div>
                <div class="flex card-page flex-wrap flex-end">
                    <img
                        src="../../../../../assets/img/softProduct/xj/巡检计划.png"
                        alt=""
                        class="app-img"
                    />
                    <div class="card-text">
                        <p class="p1">巡检计划</p>
                        <p class="p2">
                            根据巡检点的特点、巡检频次、巡检周期等制定巡检计划，并将计划派发给相关人员或班组。巡检计划类型包括日计划、周计划、月计划、频次计划等。在设定巡检计划时，可以设置巡检计划的名称、巡检人员或班组、巡检计划类型、执行时间、执行次数、巡检设备等信息。
                        </p>
                    </div>
                </div>
                <div class="flex card-page flex-wrap">
                    <div class="card-text">
                        <p class="p1">巡检任务</p>
                        <p class="p2">
                            系统根据配置的巡检计划会自动生成巡检任务，并可以下发给移动端执行。移动端接收到巡检任务后，根据要求对各巡检点进行检查，检查过程记录数据和结果，并可以拍照记录，巡检任务完成后将数据反馈到系统。
                        </p>
                    </div>
                    <img
                        src="../../../../../assets/img/softProduct/xj/巡检任务.png"
                        alt=""
                        class="app-img"
                    />
                </div>
                <div class="flex card-page flex-wrap flex-end">
                    <img
                        src="../../../../../assets/img/softProduct/xj/巡检记录.png"
                        alt=""
                        class="app-img"
                    />
                    <div class="card-text">
                        <p class="p1">巡检报表</p>
                        <p class="p2">
                            系统支持根据巡检数据生成巡检记录报表，报表内容支持定制。
                        </p>
                    </div>
                </div>
                <div class="flex card-page flex-wrap">
                    <div class="card-text">
                        <p class="p1">数据分析</p>
                        <p class="p2">
                            根据巡检任务的执行过程和结果，系统可以自动统计分析巡检的情况
                        </p>
                    </div>
                    <img
                        src="../../../../../assets/img/softProduct/xj/统计分析.png"
                        alt=""
                        class="app-img"
                    />
                </div>
                <div class="flex card-page flex-wrap flex-end">
                    <img
                        src="../../../../../assets/img/softProduct/xj/离线巡检.png"
                        alt=""
                        class="app-img"
                    />
                    <div class="card-text">
                        <p class="p1">离线巡检</p>
                        <p class="p2">
                            系统支持通过USB数据线下发巡检任务到PDA，巡检人员根据下发的任务信息持PDA终端执行巡检，巡检过程中记录检查数据和结果，也可以进行拍照，巡检完成后可以将执行结果同步到PC端系统，形成巡检记录。
                        </p>
                    </div>
                </div>
                <div class="img-bottom"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {}
</script>
<style scoped lang="less">
@import './softProduct.less';
</style>
